module.exports = __webpack_public_path__ + "img/logo-keyvue-premium-plus.db563706.svg";